import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionCampaignNode, CommissionCampaignStatus } from "./types";

export interface CommissionCampaignsQueryResponse {
  commissionCampaigns: {
    nodes: CommissionCampaignNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionCampaignsQueryVariables extends PaginationVariables {
  partnerId?: string;
  editionYear?: number;
  status?: CommissionCampaignStatus;
}

export const COMMISSION_CAMPAIGNS_QUERY: TypedDocumentNode<
  CommissionCampaignsQueryResponse,
  CommissionCampaignsQueryVariables
> = gql`
  query CommissionCampaigns(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $partnerId: ID
    $editionYear: Int
    $status: BackofficeCommissionCampaignStatus
  ) {
    commissionCampaigns(
      first: $first
      after: $after
      last: $last
      before: $before
      partnerId: $partnerId
      editionYear: $editionYear
      status: $status
    ) {
      nodes {
        id
        editionYear
        status
        payoutCadence
        eligibilityRules {
          id
        }
        startsAt
        endsAt
        startsOn
        endsOn
        partner {
          id
          name
          currentIngestRecipe {
            id
          }
        }
        program {
          id
          name
          slug
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
